import React from 'react'

const Software = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="59"
      viewBox="0 0 59 59"
    >
      <g>
        <g>
          <path
            fill="#fe4c4c"
            d="M0 5a5 5 0 0 1 5-5h49a5 5 0 0 1 5 5v49a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z"
          />
        </g>
        <g>
          <g>
            <path
              fill="#fff"
              d="M24.414 5H4.817A.81.81 0 0 0 4 5.802V34.66a.81.81 0 0 0 .817.802h7.349v-1.604H5.633V6.603h17.965v1.603h1.633V5.802A.81.81 0 0 0 24.414 5z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M11.082 10.771l-.616.308-.615-.308v-.47l.615-.308.616.308zm.89-1.4l-1.23-.616a.615.615 0 0 0-.55 0L8.96 9.37a.615.615 0 0 0-.34.55v1.231c0 .234.132.447.34.551l1.231.615a.615.615 0 0 0 .55 0l1.231-.615a.615.615 0 0 0 .34-.55V9.92a.615.615 0 0 0-.34-.55z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M35.579 38.478h-19.78V11.223h19.78zm.824-28.858H14.974a.813.813 0 0 0-.824.802V39.28c0 .443.369.802.824.802h21.429a.813.813 0 0 0 .824-.802V10.422a.813.813 0 0 0-.824-.802z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M28.15 24.988l-2.531 1.004v-2.381l2.53-1.004zm-3.378-2.846l-1.954-.775 1.954-.774 1.954.774zm-.857 3.85l-2.531-1.004v-2.381l2.53 1.004zm5.894-4.854c-.007-.023-.018-.044-.026-.066a.812.812 0 0 0-.217-.318c-.02-.019-.04-.038-.062-.055s-.02-.02-.032-.027a.937.937 0 0 0-.116-.058c-.016-.008-.027-.02-.044-.026l-4.23-1.679a.867.867 0 0 0-.63 0l-4.23 1.679c-.018.006-.03.019-.046.026a.91.91 0 0 0-.115.058c-.01.008-.019.019-.03.027-.013.009-.042.036-.063.055a.888.888 0 0 0-.149.176.817.817 0 0 0-.068.142c-.009.022-.02.043-.026.066a.832.832 0 0 0-.035.23v4.195c0 .343.21.652.531.78l4.231 1.678c.01 0 .021 0 .031.006a.776.776 0 0 0 .567 0c.01 0 .022 0 .032-.006l4.23-1.678a.84.84 0 0 0 .532-.78v-4.196a.832.832 0 0 0-.035-.229z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M52.208 17.15H40.721v-6.766h11.487zm.82-8.46H39.902a.834.834 0 0 0-.821.846v8.462c0 .467.367.846.82.846H53.03c.453 0 .82-.379.82-.846V9.536a.834.834 0 0 0-.82-.846z"
            />
          </g>
          <g>
            <path fill="#fff" d="M41.85 13.31h1.846v1.846H41.85z" />
          </g>
          <g>
            <path
              fill="#fff"
              d="M52.208 29.15H40.721v-6.766h11.487zm.82-8.46H39.902a.834.834 0 0 0-.821.846v8.462c0 .467.367.846.82.846H53.03c.453 0 .82-.379.82-.846v-8.462a.834.834 0 0 0-.82-.846z"
            />
          </g>
          <g>
            <path fill="#fff" d="M41.85 25.31h1.846v1.846H41.85z" />
          </g>
          <g>
            <path fill="#fff" d="M46.46 25.31h3.692v1.846H46.46z" />
          </g>
          <g>
            <path
              fill="#fff"
              d="M30.935 51.296H14.002v-8.582h16.933zM31.772 41H13.156a.852.852 0 0 0-.846.857v10.286c0 .473.379.857.846.857h18.616a.852.852 0 0 0 .846-.857V41.857a.852.852 0 0 0-.846-.857z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M50.315 43.576c0 .477-.379.863-.846.863h-15.24a.855.855 0 0 1-.847-.863v-.862h16.933zm0 7.71H33.382v-5.3c.271.1.558.154.847.157h15.24c.289-.003.575-.056.846-.158zM51.152 41H32.536a.852.852 0 0 0-.846.857v10.286c0 .473.379.857.846.857h18.616a.852.852 0 0 0 .846-.857V41.857a.852.852 0 0 0-.846-.857z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M18.462 46.777l-.616.31-.615-.31v-.474l.615-.31.616.31zm.89-1.407l-1.23-.615a.616.616 0 0 0-.55 0l-1.232.615a.615.615 0 0 0-.34.55v1.23a.615.615 0 0 0 .34.553l1.231.614a.616.616 0 0 0 .55 0l1.231-.614a.615.615 0 0 0 .34-.554v-1.23a.615.615 0 0 0-.34-.55z"
            />
          </g>
          <g>
            <path fill="#fff" d="M36.31 48.38h1.846v1.846H36.31z" />
          </g>
          <g>
            <path fill="#fff" d="M40 48.38h3.692v1.846H40z" />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Software
